// extracted by mini-css-extract-plugin
export var sliderRange = "_mx-2";
export var sliderRoot = "_mx-0";
export var sliderThumb = "_mx-3";
export var sliderTrack = "_mx-1";